// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Deletes a field from an item's configuration.
 * This permanently removes the field and any associated metadata values.
 * This operation cannot be undone.
 *
 * @param itemKey - The key of the item that owns the field
 * @param fieldKey - The key of the field to delete
 * @returns A promise that resolves to a success response with request metadata
 */
export async function deleteItemField(itemKey: string, fieldKey: string) {
  const url = `/v1/catalog/item/${itemKey}/field/${fieldKey}`;
  const response = await api.delete(url);

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteItemField',
    endpoint: url,
  });
}
